export default class Eventlist {
    init(root) {
        this.root = root;
        this.buttons = root.querySelectorAll('[data-filter]');
        this.items = root.querySelectorAll('.eventlist-item');
        this.activeFilter = null;

        this.setupFilterButtons();
    }

    setupFilterButtons() {
        this.buttons.forEach(button => {
            button.addEventListener('click', () => {
                const filter = button.getAttribute('data-filter');

                // Toggle logic
                if (this.activeFilter === filter) {
                    // Deselect filter
                    this.activeFilter = null;
                    this.updateUI();
                } else {
                    // Set new filter
                    this.activeFilter = filter;
                    this.updateUI();
                }
            });
        });
    }

    updateUI() {
        // Toggle active button style
        this.buttons.forEach(button => {
            const isActive = button.getAttribute('data-filter') === this.activeFilter;
            button.classList.toggle('active', isActive);
        });

        // Show/hide event items
        this.items.forEach(item => {
            const itemFilter = item.getAttribute('data-filter');

            const show = !this.activeFilter || itemFilter === this.activeFilter;
            item.style.display = show ? '' : 'none';
        });
    }
}
